<template>
  <div>
    <el-dialog top="40px" title="详情" class="view-file" :visible.sync="dialogVisible" :close-on-click-modal="false" modal-append-to-body @close="onClose" width="1000px">

      <div class="view-file-win">
        <div class="view-file-header">
          <el-date-picker
            style="width: 150px"
            v-model="where.year"
            size="mini"
            type="year"
            format="yyyy"
            value-format="yyyy"
            placeholder="选择年份" @change="getDetailsReason()">
          </el-date-picker>
        </div>
        <el-descriptions v-if="reason_data" class="margin-top" :column="2" size="mini" border v-loading="loading1">
          <el-descriptions-item label="房产">{{ reason_data.HouseName }}</el-descriptions-item>
          <el-descriptions-item label="姓名">{{ reason_data.name }}</el-descriptions-item>
          <el-descriptions-item label="电话">{{ reason_data.phone }}</el-descriptions-item>
          <el-descriptions-item label="欠费类型">{{ reason_data.arrears_type }}</el-descriptions-item>
<!--          <el-descriptions-item label="欠费原因">{{ reason_data.arrears_reason }}</el-descriptions-item>-->
          <el-descriptions-item :label="reason_data.type==5&&reason_data.type_ex==2?'诉调案号':(reason_data.type==5&&reason_data.type_ex==3?'受理案件号':'业主诉求')">{{ reason_data.user_appeal }}</el-descriptions-item>
          <el-descriptions-item label="催缴措施">{{ reason_data.measures }}</el-descriptions-item>
          <el-descriptions-item label="预计回款时间">{{ reason_data.ymd }}</el-descriptions-item>
          <el-descriptions-item label="催缴责任人">{{ reason_data.user_person_liable }}</el-descriptions-item>
          <el-descriptions-item label="备注">{{ reason_data.remarks }}</el-descriptions-item>
          <el-descriptions-item label="添加时间">{{ reason_data.created_at }}</el-descriptions-item>
        </el-descriptions>
        <div>
          <header-tip>
            催缴记录条数：{{pageData.total}}
          </header-tip>
          <el-button type="primary" size="mini" @click="openAIChart">AI分析</el-button>
          <el-button type="primary" size="mini" @click="openAIChart1">AI回答（解决措施）</el-button>
          <el-button type="primary" size="mini" @click="openCustomerProfile(reason_data.ch_md5)">客户画像</el-button>
        </div>
        <div class="main-log" v-loading="loading2">
          <div class="chart">
            <AIChart v-if="dialogVisible" ref="AIChart" />

          </div>
          <div class="log">
            <el-steps size="mini" v-if="list.length>0" :space="150" direction="vertical" :active="list.length">
              <el-step v-for="(item,index) in list" :key="index">
                <template slot="title">
                  <div>{{item.send_time}}</div>
                  <p style="color:#414141;font-size: 14px;">
                    类型：<span style="color: #656565">{{item.type_text}}</span>
                  </p>
                  <p style="color:#414141;font-size: 14px;">
                    操作人：<span style="color: #757575">{{item.work_name||'系统同步'}}</span>
                  </p>
                  <p style="color:#414141;font-size: 14px;" v-if="item.type!==10">
                    催缴金额：<span style="color: #ff3d00;font-size: 16px;font-weight: bold;">{{item.money}}</span>
                  </p>
                  <p style="color:#414141;font-size: 14px;" v-if="item.type===10">
                    缴费金额：<span style="color: #ff3d00;font-size: 16px;font-weight: bold;">{{item.money}}</span>
                  </p>
                  <p style="color:#414141;font-size: 14px;" v-if="item.type===10">
                    缴费方式：<span style="color: #757575">{{item.measures}}</span>
                  </p>
                  <p style="color:#414141;font-size: 14px;" v-if="item.type!==10">
                    业主原话：<span style="color: #757575">{{item.owner_words}}</span>
                  </p>
                  <p style="color:#414141;font-size: 14px;" v-if="item.type!==10">
                    备注：<span style="color: #757575">{{item.remarks}}</span>
                  </p>
                  <p style="color:#414141;font-size: 14px;" v-if="item.type===10">
                    缴费日期：<span style="color: #757575">{{item.created_at}}</span>
                  </p>
                  <p style="color:#414141;font-size: 14px;" v-if="item.type!==10">
                    添加时间：<span style="color: #757575">{{item.created_at}}</span>
                  </p>
                </template>
                <template slot="description">
                  <div v-if="(item.extend||'').indexOf('http')===-1" style="color: #6f7175">
                    {{item.extend}}
                  </div>
                  <div v-else>
                    <div v-for="(img,img_index) in item.extendImg" :key="img_index">
                      <el-popover
                        v-if="img"
                        placement="top-start"
                        title="预览"
                        width="500"
                        trigger="hover">
                        <el-image
                          style="width: 470px;"
                          :src="img"
                          fit="contain"></el-image>
                        <el-image
                          slot="reference"
                          style="width: 200px; height: 200px"
                          :src="img"
                          fit="contain"></el-image>
                      </el-popover>
                      <el-link type="primary" @click="openFile(img,1)">预览<i class="el-icon-view el-icon--right"></i> </el-link>&nbsp;&nbsp;&nbsp;&nbsp;
                      <el-link type="primary" @click="openFile(img,2)">下载<i class="el-icon-download el-icon--right"></i> </el-link>
                    </div>

                  </div>
                </template>
              </el-step>
            </el-steps>
          </div>
        </div>
        <div class="main-log-bottom">
          <el-button round size="mini" type="primary" @click="load()">加载更多</el-button>
        </div>
      </div>
      <template slot="footer">
        <div>
          <el-button icon="el-icon-close" @click="dialogVisible=false">关 闭</el-button>
        </div>
      </template>
    </el-dialog>
    <HouseCategorySpeech ref="HouseCategorySpeech" />
  </div>
</template>

<script>
import LogController from "../../../../common/logger/LogController";
import ViewFileHelp from "../../../../common/ViewFileHelp";
import ButlerHttp from "../common/ButlerHttp";
import moment from "moment";
import HeaderTip from "../../Common/header-tip";
import AIChart from "./ai/AIChart";
import HouseCategorySpeech from "./ai/HouseCategorySpeech";

export default {
  name: "LegalHouseInfo",
  components: {HouseCategorySpeech, AIChart, HeaderTip},
  data(){
    return{
      dialogVisible:false,
      project_id:0,
      house_id:0,
      where:{
        year:moment().format("YYYY"),
      },
      reason_data:{},
      list:[],
      pageData:{
        current_page: 1,
        per_page: 30,
        data:[],
        total:0
      },
      loading1:false,
      loading2:false,
    }
  },
  methods:{
    show(item){
      const that=this;
      that.project_id=item.project_house_id;
      that.house_id=item.house_id;

      LogController.start({
        group_name: "抽检记录",
        group_key: item.project_house_id,
        group_val: item.house_id,
        remarks: ""
      }, that.$route.path + "_1");

      that.getDetailsReason();
      // that.getDetailsList();
      that.load();
    },
    getDetailsReason(){
      const that=this;
      that.loading1=true;
      ButlerHttp.get("Legal/getDetailsReason", {
        precinctid: that.project_id,
        houseid: that.house_id,
        cyear2: that.where.year,
      }, res => {
        that.loading1=false;
        if (res.code) {
          that.dialogVisible = true;
          that.reason_data=res.data;
        } else {
          that.$message.error(res.msg || "无法访问");
        }
      });
    },
    load(){
      const that=this;
      that.getDetailsList()
    },
    getDetailsList(){
      const that=this;
      that.loading2=true;
      ButlerHttp.get("Legal/getDetailsList?page="+that.pageData.current_page, {
        precinctid: that.project_id,
        houseid: that.house_id
      }, res => {
        that.loading2=false;
        if (res.code) {

          res.data.data.map(ret_item => {
            if ((ret_item.extend || "").indexOf('http') === -1) {
              ret_item.extendImg = [];
            } else {
              ret_item.extendImg = ret_item.extend.split(",");
            }
          });
          that.list = that.list.concat(res.data.data);
          that.pageData = res.data;
          if(res.data.data.length>0){
            that.pageData.current_page=that.pageData.current_page+1;
          }else {
            that.$message.error("已经加载完！");
          }
        } else {
          that.$message.error(res.msg || "无法访问");
        }
      });
    },
    onClose(){
      this.dialogVisible=false;
      this.reason_data={};
      this.pageData.current_page=1;
      this.list=[];
      LogController.end(this.$route.path+"_1")
    },
    openFile(file,type=1){
      if(type===1){
        window.open(ViewFileHelp.getViewFileUrl(file))
      }else {
        // console.log(file)
        //把http转成https
        file = file.replace("http://","https://");
        //下载文件
        let aLink = document.createElement('a');
        aLink.href = file;
        aLink.download = file.substring(file.lastIndexOf("/") + 1);
        document.body.appendChild(aLink);
        aLink.click();
        document.body.removeChild(aLink);
      }
    },
    openAIChart(){
      const that=this;
      //{
    //   "butler_id": 4550,
    //     "type_text": "成功催缴",
    //     "type": 10,
    //     "measures": "转账",
    //     "send_time": "2025-12-19",
    //     "extend": "",
    //     "created_at": "2025-12-19 19:05:07",
    //     "money": "3323.65",
    //     "owner_words": "",
    //     "remarks": "系统自动同步",
    //     "work_name": "鼎旺管家（写字楼/商铺）"
    // }
      let systemData=`
你是物业公司的催缴分析专员，负责基于业主的催缴历史，分析以下内容：
1.  **信息解析**：
butler_id：管家ID（催缴操作人ID）
send_time：催缴时间
type:催缴类型ID
type_text：催缴类型
work_name：催缴操作人
money：催缴金额
measures：缴费方式（也包含了回款）
owner_words：业主原话
remarks：备注
created_at：登记时间

2.  **输出结果**：
- 目标：分析业主诉求、欠费原因、需要采取的措施，如何提高客户满意度，达成催缴任务（200字）。
- 要求：结构清晰，语句清楚，表述专业，客观回答。
- 附加：用物业工作者的口吻，表述下一次的催缴话术（100字左右）。

      `;
      const userData=`
## 业户基本信息：
- 房产：${that.reason_data.HouseName}
- 姓名：${that.reason_data.name}
- 电话：${that.reason_data.phone}
- 欠费类型：${that.reason_data.arrears_type}
- 欠费原因：${that.reason_data.arrears_reason}
- ${that.reason_data.type==5&&that.reason_data.type_ex==2?'诉调案号':(that.reason_data.type==5&&that.reason_data.type_ex==3?'受理案件号':'业主诉求')}：${that.reason_data.user_appeal}
- 催缴措施：${that.reason_data.measures}
- 预计回款时间：${that.reason_data.ymd}
- 催缴责任人：${that.reason_data.user_person_liable}
- 备注：${that.reason_data.remarks}

## 请分析以下业主的催缴历史：
${JSON.stringify(that.list, null, 2)}
      `;
      that.$refs.AIChart.show([
        { role: 'system', content: systemData },
        { role: 'user', content: userData },
      ])

      // that.$refs.AIChart.show([
      //   { role: 'system', content: "你是物业催费助手。" },
      //   { role: 'user', content: "你好" },
      // ])
    },
    openAIChart1(){
      const that=this;
      // that.$message.success("功能开发中")
      that.$refs.HouseCategorySpeech.show(that.reason_data.ch_md5)
    },
    openCustomerProfile(ch_md5){
      // 打开客户画像 - 弹出窗口(800*600,无工具栏，无菜单栏，可滚动，可调整大小，无状态栏,居中)
      let features = "width=800,height=600,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,status=no,left=" + (screen.width - 800) / 2 + ",top=" + (screen.height - 600) / 2;
      window.open("http://183.56.221.57:9053/profile?ch_md5="+ch_md5,"_blank",features);
    }
  }
}
</script>

<style lang="scss" scoped>
.el-button--primary,.el-button--success,.el-button--danger,.el-button--warning {
  color: #FFF;
}

.view-file{
  >>> .el-dialog__body{
    padding: 5px 20px;
  }
  .view-file-win{
    .main-log{
      height: 50vh;
      border: solid 1px #e2e2e2;
      position: relative;

      .chart{
        position: absolute;
        top: 10px;
        right: 10px;
        width: 400px;
        height: 45vh;
        z-index: 2;
      }
      .log{
        height: 50vh;
        overflow-y: scroll;
      }

    }
    .main-log-bottom{
      margin-top: 10px;
      text-align: center;
      display: flex;
      flex-direction: row;
      justify-content: center;
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/LegalHouseInfo.vue